export default __webpack_public_path__ + "static/media/btc.c33e6151.svg";